// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useMemo, useRef } from 'react'
import { Avatar, MenuOption, Picker } from '@teamnine/pcj-ui-v2'
import { User, useAuth0 } from '@auth0/auth0-react'

type UserPickerProps = {
  user?: User
  isCollapsed: boolean
}

export default function UserPicker({ user, isCollapsed }: UserPickerProps) {
  const { logout } = useAuth0()

  const pickerLabel = user?.name || 'Account'
  const pickerInitial = pickerLabel.charAt(0).toUpperCase()

  const menuOptions: MenuOption[] = useMemo(() => {
    const optionList = []
    const availableOptions = [
      {
        label: 'Log Out',
        onClick: () =>
          logout({
            returnTo: window.location.origin,
          }),
      },
    ]
    optionList.push(...availableOptions)
    return optionList as MenuOption[]
  }, [logout])
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <Picker
      prefix={<Avatar src={user?.picture}>{pickerInitial}</Avatar>}
      label={pickerLabel}
      menuOptions={menuOptions}
      container={containerRef.current}
      isCollapsed={isCollapsed}
      collapsedAppearance="avatar"
      variant="inverse"
      borderless
      menuIcon="kebab"
    />
  )
}
